export default __webpack_public_path__ + "static/media/avatar4-mujer.e9fbc2e9.png";